import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiHandlerService } from "../services/api-handler.service";
import { StorageService } from "../services/storage.service";
import { Router } from "@angular/router";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CmnFunctionService {
  //below we decllare all variables...
  public passwordRegex =
    "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{6,})$";
  public emailRegex = /\S+@\S+\.\S+/;
  public userInfo: any;
  public userValue: any;
  updatedPageData = new BehaviorSubject("");

  constructor(
    public apiService: ApiHandlerService,
    public storage: StorageService,
    public router: Router
  ) {
    this.userInfo = new BehaviorSubject(
      JSON.parse(localStorage.getItem("userData"))
    );
  }

  public set updateUserInfo(value: string) {
    this.userInfo.next(value);
  }

  //keyPress for add only 10 digit number..
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  //getUserDetails function for get user info..
  getUserDetails() {
    return this.apiService.apiGet(this.apiService.baseUrl + "my-details").pipe(
      tap((resp) => {
        if (resp.data) {
          localStorage.userData = JSON.stringify(resp.data);
        }
      })
    );
  }

  getSiteUserDetails() {
    return this.apiService
      .apiGet(this.apiService.baseApiUrl + "site/my-details")
      .pipe(
        tap((resp) => {
          if (resp.data) {
            localStorage.userData = JSON.stringify(resp.data);
          }
        })
      );
  }

  //getUserDetailAfterSignup function for get user info..
  getUserDetailAfterSignup() {
    return this.apiService.apiGet(
      this.apiService.baseUrl + "my-details",
      null,
      {
        customHeaders: {
          Authorization: JSON.parse(localStorage.getItem("userData"))
            .accessToken,
        },
      }
    );
  }

  //updateUserDetails for update user detail...
  updateUserDetails(data: any) {
    return this.apiService.apiUpdate(
      this.apiService.baseUrl + "edit-user",
      data,
      null,
      {
        customHeaders: {
          Authorization: JSON.parse(localStorage.getItem("userData"))
            .accessToken,
        },
      }
    );
  }

  //uploadProfileImage for upload image..
  uploadProfileImage(fileToUpload: File, role: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("file", fileToUpload, fileToUpload.name);
    formData.append("role", role);
    formData.append("type", role);
    return this.apiService.apiPost(
      this.apiService.baseUrl + "upload",
      formData,
      null,
      { customHeaders: { Authorization: "" } }
    );
  }

  //uploadProfileImage for upload image..
  uploadVehicleImage(fileToUpload: File, role: any, filename): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("file", fileToUpload, filename);
    formData.append("type", role);
    formData.append("role", role);
    return this.apiService.apiPost(
      this.apiService.baseUrl + "upload",
      formData,
      null,
      { customHeaders: { Authorization: "" } }
    );
  }

  //mangeBackButtonActivity for back button mange..
  mangeBackButtonActivity() {
    const token = this.storage.getUserToken();
    const userData = this.storage.fetchUserStorageData();
    if (token) {
      userData.role == "Customer"
        ? this.router.navigate(["/customer/dashboard"])
        : this.router.navigate(["/driver/dashboard"]);
      return false;
    } else {
      this.router.navigate(["/auth"]);
    }
  }

  updateData(data: any) {
    this.userInfo.next(data);
  }
}
